import { Box, BoxProps, Skeleton } from '@radix-ui/themes';

import styles from './LoadingLayer.module.css';

type LoadingLayerProps = BoxProps & {
    isLoading: boolean;
};

export const LoadingLayer = ({
    isLoading,
    children,
    ...props
}: LoadingLayerProps) => {
    if (!isLoading) return children;
    return (
        <Box className={styles.loadingOverlay} {...props}>
            <Skeleton width={'100%'} height={'100%'} />
        </Box>
    );
};
